import { Store } from 'lucide-react';
import { Badge } from '@/components/ui/Badge';
import { useChannelStore, useHasMultipleStores } from './usePharmacyStores';
import type { PharmacyChannel } from './types';

/**
 * "Selling from OP Pharmacy" on a selling screen — which store its stock and
 * sales come from (the channel's store, decided by the server). Renders
 * nothing at a single-store branch, so a hospital that hasn't split its
 * pharmacy sees no change.
 */
export function StoreBadge({ channel, verb = 'Selling from' }: { channel: PharmacyChannel; verb?: string }) {
  const multiple = useHasMultipleStores();
  const store = useChannelStore(channel);
  if (!multiple || !store) return null;
  return (
    <Badge variant="info" className="gap-1" title={`Stock on this screen is ${store.name}'s. Change it in Admin → Pharmacy Stores.`}>
      <Store className="h-3 w-3" aria-hidden />
      {verb} {store.name}
    </Badge>
  );
}
